import React from 'react';
import { Option } from '../../types/quiz';

const ICON_MAP: Record<string, string> = {
  wrench: '🔧',
  magnifier: '🔍',
  paintbrush: '🎨',
  people: '👥',
  rocket: '🚀',
  clipboard: '📋',
  tools: '🛠️',
  brain: '🧠',
  lightbulb: '💡',
  heart: '❤️',
  arrow_up: '📈',
  checklist: '✅',
  hammer: '🔨',
  microscope: '🔬',
  palette: '🎭',
  handshake: '🤝',
  chart: '📊',
  folder: '📁',
};

interface Props {
  option: Option;
  selected: boolean;
  onSelect: (id: string) => void;
}

const OptionCard: React.FC<Props> = ({ option, selected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(option.id)}
      className={`w-full flex flex-col items-center justify-center gap-2 p-4 rounded-xl border-2 transition-all duration-200 text-center
        ${selected
          ? 'border-scaleo-blue bg-blue-50 shadow-md scale-[1.02]'
          : 'border-gray-200 bg-white hover:border-scaleo-blue hover:shadow-sm hover:scale-[1.01]'
        }`}
    >
      <span className="text-3xl">{ICON_MAP[option.icon_key] || '⭐'}</span>
      <span className={`text-sm leading-snug font-medium ${selected ? 'text-scaleo-blue' : 'text-gray-700'}`}>
        {option.text}
      </span>
    </button>
  );
};

export default OptionCard;
